import { z } from '@harvestiq/zod';
import { dbClaimDocumentInsertSchema } from './db-claim-documents';

export const claimDocumentUploadSchema = dbClaimDocumentInsertSchema
  .omit({
    s3Key: true,
    uploadStatus: true,
    uploadedAt: true,
  })
  .extend({
    orgId: z.string(),
  });

export type ClaimDocumentUpload = z.infer<typeof claimDocumentUploadSchema>;
